<template>
  <div>
    <div style="margin: 10px 0">
      <el-input style="width: 200px" placeholder="请输入商品名称" suffix-icon="el-icon-search" v-model="title"></el-input>
      <el-button class="ml-5" type="primary" @click="load">搜索</el-button>
      <el-button type="warning" @click="reset">重置</el-button>
    </div>

    <div style="margin: 10px 0">
      <el-button type="primary" @click="handleAdd">新增 <i class="el-icon-circle-plus-outline"></i></el-button>
      <el-popconfirm
          class="ml-5"
          confirm-button-text='确定'
          cancel-button-text='我再想想'
          icon="el-icon-info"
          icon-color="red"
          title="您确定批量删除这些数据吗？"
          @confirm="delBatch"
      >
        <el-button type="danger" slot="reference">批量删除 <i class="el-icon-remove-outline"></i></el-button>
      </el-popconfirm>
      <!-- <el-upload action="http://localhost:9090/product/import" :show-file-list="false" accept="xlsx" :on-success="handleExcelImportSuccess" style="display: inline-block">
        <el-button type="primary" class="ml-5">导入 <i class="el-icon-bottom"></i></el-button>
      </el-upload>
      <el-button type="primary" @click="exp" class="ml-5">导出 <i class="el-icon-top"></i></el-button> -->
    </div>

    <el-table :data="tableData" border stripe :header-cell-class-name="'headerBg'"  @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="ID" width="80" sortable></el-table-column>
      <el-table-column prop="title" label="商品名称" min-width="200"></el-table-column>
      <el-table-column prop="price" label="价格" width="120">
        <template slot-scope="scope">
          <span style="color: #f56c6c; font-weight: bold;">¥{{ (scope.row.price / 100).toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="originalPrice" label="原始价格" width="120">
        <template slot-scope="scope">
          <span style="color: #999; text-decoration: line-through;">¥{{ (scope.row.originalPrice / 100).toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="points" label="获得积分" width="120">
        <template slot-scope="scope">
          <el-tag type="success">{{ scope.row.points }} 积分</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>

      <el-table-column label="操作"  width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="small" @click="handleEdit(scope.row)">编辑 <i class="el-icon-edit"></i></el-button>
          <el-popconfirm
              class="ml-5"
              confirm-button-text='确定'
              cancel-button-text='我再想想'
              icon="el-icon-info"
              icon-color="red"
              title="您确定删除吗？"
              @confirm="del(scope.row.id)"
          >
            <el-button type="danger" size="small" slot="reference">删除 <i class="el-icon-remove-outline"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="padding: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[2, 5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <el-dialog title="商品信息" :visible.sync="dialogFormVisible" width="40%" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px" size="small" style="width: 95%">
        <el-form-item label="商品名称" prop="title">
          <el-input v-model="form.title" placeholder="请输入商品名称"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="价格（元）" prop="price">
              <el-input-number 
                v-model="priceYuan" 
                :precision="2" 
                :step="0.1" 
                :min="0" 
                style="width: 100%"
                placeholder="请输入价格"
                @change="handlePriceChange">
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原价（元）" prop="originalPrice">
              <el-input-number 
                v-model="originalPriceYuan" 
                :precision="2" 
                :step="0.1" 
                :min="0" 
                style="width: 100%"
                placeholder="请输入原价"
                @change="handleOriginalPriceChange">
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="获得积分" prop="points">
          <el-input-number 
            v-model="form.points" 
            :precision="2" 
            :step="1" 
            :min="0" 
            style="width: 100%"
            placeholder="请输入获得的积分数">
          </el-input-number>
          <div style="color: #909399; font-size: 12px; margin-top: 5px;">
            <i class="el-icon-info"></i> 用户购买此商品后获得的积分
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    // 添加价格验证规则
    const validatePrice = (rule, value, callback) => {
      if (this.form.originalPrice && this.form.price > this.form.originalPrice) {
        callback(new Error('价格不能高于原始价格'))
      } else {
        callback()
      }
    }
    return {
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      title: "",
      form: {
        id: null,
        title: '',
        price: null,
        originalPrice: null,
        points: null
      },
      rules: {
        title: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          { validator: validatePrice, trigger: 'blur' }
        ],
        originalPrice: [
          { required: true, message: '请输入原始价格', trigger: 'blur' }
        ],
        points: [
          { required: true, message: '请输入获得积分', trigger: 'blur' }
        ]
      },
      priceYuan: null, // 用于显示的元单位价格
      originalPriceYuan: null, // 用于显示的元单位原价
      dialogFormVisible: false,
      multipleSelection: [],
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.request.get("/product/page", {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          title: this.title,
        }
      }).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.request.post("/product", this.form).then(res => {
            if (res.code === '200') {
              this.$message.success("保存成功")
              this.dialogFormVisible = false
              this.load()
            } else {
              this.$message.error("保存失败")
            }
          })
        }
      })
    },
    handleAdd() {
      this.form = {
        id: null,
        title: '',
        price: null,
        originalPrice: null,
        points: null
      }
      this.priceYuan = null
      this.originalPriceYuan = null
      this.dialogFormVisible = true
      this.$nextTick(() => {
        if(this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleEdit(row) {
      this.form = JSON.parse(JSON.stringify(row))
      // 将分转换为元显示
      this.priceYuan = this.form.price ? (this.form.price / 100) : null
      this.originalPriceYuan = this.form.originalPrice ? (this.form.originalPrice / 100) : null
      this.dialogFormVisible = true
      this.$nextTick(() => {
        if(this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 处理价格变化（元转分）
    handlePriceChange(value) {
      this.form.price = value ? Math.round(value * 100) : null
      if (this.$refs.form) {
        this.$refs.form.validateField('price')
      }
    },
    // 处理原价变化（元转分）
    handleOriginalPriceChange(value) {
      this.form.originalPrice = value ? Math.round(value * 100) : null
      if (this.$refs.form) {
        this.$refs.form.validateField('price')
      }
    },
    del(id) {
      this.request.delete("/product/" + id).then(res => {
        if (res.code === '200') {
          this.$message.success("删除成功")
          this.load()
        } else {
          this.$message.error("删除失败")
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
    },
    delBatch() {
      if (!this.multipleSelection.length) {
        this.$message.error("请选择需要删除的数据")
        return
      }
      let ids = this.multipleSelection.map(v => v.id)  // [{}, {}, {}] => [1,2,3]
      this.request.post("/product/del/batch", ids).then(res => {
        if (res.code === '200') {
          this.$message.success("批量删除成功")
          this.load()
        } else {
          this.$message.error("批量删除失败")
        }
      })
    },
    reset() {
      this.title = ""
      this.load()
    },
    handleSizeChange(pageSize) {
      console.log(pageSize)
      this.pageSize = pageSize
      this.load()
    },
    handleCurrentChange(pageNum) {
      console.log(pageNum)
      this.pageNum = pageNum
      this.load()
    },
    handleFileUploadSuccess(res) {
      this.form.file = res
    },
    handleImgUploadSuccess(res) {
      this.form.img = res
    },
    download(url) {
      window.open(url)
    },
    exp() {
      window.open("http://localhost:9090/product/export")
    },
    handleExcelImportSuccess() {
      this.$message.success("导入成功")
      this.load()
    }
  }
}
</script>


<style>
.headerBg {
  background: #eee!important;
}
</style>
